import { Loader } from "react-feather";

const Loading = () => (
  <div className="d-flex w-100 mb-5">
    <Loader className="text-muted fa-spin flex-grow-1" />
  </div>
);

export default Loading;
